<template>
    <div v-if="pageData" class="pt-40 pb-12">
        <div class="max-w-screen-lg mx-auto">
            <div class="flex items-center justify-center mb-12 ">
                <brush-stroke-bg :variant="2">
                    <h2 class="font-primary text-3xl sm:text-4xl text-white">
                        {{ pageData.title }}
                    </h2>
                </brush-stroke-bg>
            </div>

            <div
                v-html="pageData.value"
                class="font-secondary text-lg text-blue px-4 sm:px-8"
            ></div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import BrushStrokeBg from "../components/BrushStrokeBg";

export default {
    name: "content-page",

    components: { BrushStrokeBg },

    props: {
        pageName: {
            type: String,
            required: true
        }
    },

    created() {
        this.$store.dispatch("FETCH_CONTENT_PAGES");
    },

    computed: {
        ...mapState(["contentPages"]),
        ...mapGetters(["getContentPage"]),

        pageData() {
            return this.getContentPage(this.pageName);
        }
    }
};
</script>
